// src/mixin/navigationMixin.js
export default {
	methods: {
		getRouteUrl(name, params = {}, query = {}) {
			const currentChannel = this.$route.params.channel
			let routeName = name
			let finalParams = { ...params }

			if (currentChannel) {
				const channelRoutes = {
					home: 'homechannel',
					all: 'channelAll',
					rankings: 'channelRankings',
					detail: 'channelDetail',
					about: 'channelabout',
					privacy: 'channelprivacy',
					terms: 'channelterms',
					disclaimer: 'channeldisclaimer',
				}
				if (channelRoutes[name]) {
					routeName = channelRoutes[name]
					finalParams.channel = currentChannel
				} else if (name === 'home' && !params.channel) {
					routeName = 'homechannel'
					finalParams.channel = currentChannel
				}
			}

			try {
				const { href } = this.$router.resolve({
					name: routeName,
					params: finalParams,
					query,
				})
				return href
			} catch (error) {
				console.error(`Could not resolve route for name: ${name}`, error)
				return '#'
			}
		},

		getCarDetailUrl(car) {
			if (!car || !car.id) return '#'
			const formattedName = encodeURIComponent((car.model || car.name || '').replace(/\s+/g, '-'))
			const params = {
				carName: formattedName,
				id: car.id,
			}
			return this.getRouteUrl('detail', params, this.$route.query)
		},

		getCarListUrl(query = {}) {
			return this.getRouteUrl('all', {}, query)
		},
	},
}
